const cashBacks = [
    4,
    9,
    15,
    22,
    30,
    39,
    49,
    60,
    72,
    85,
    99,
    114,
    129,
    144,
    159,
    174,
    159,
    189,
    204,
    219,
    234,
    249,
    260,
    280,
    300,
    320,
    340,
    360,
    370,
    380,
    390,
    400,
    420,
    450,
    500,
    550,
    600,
    650,
    700,
    800,
    900,
]

export default cashBacks